/** Se uma tela quebrar, mostra o aviso (em vez de página em branco) e deixa voltar. */
import { Component, type ReactNode } from "react";

export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  override componentDidUpdate(prev: { resetKey?: string }) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  override componentDidCatch(error: Error) { console.error("Tela com erro:", error); }
  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="card" style={{ maxWidth: 640 }}>
        <h2>Algo deu errado nesta tela</h2>
        <p className="muted">O restante do sistema continua funcionando. Volte e tente de novo; se repetir, me envie o texto abaixo.</p>
        <pre className="small" style={{ whiteSpace: "pre-wrap", background: "var(--surface)", padding: 10, borderRadius: 6 }}>{this.state.error.message}</pre>
        <div className="row">
          <button className="btn" onClick={() => history.back()}>Voltar</button>
          <button className="btn primary" onClick={() => location.reload()}>Recarregar</button>
        </div>
      </div>
    );
  }
}
